import React from 'react';
import './Header.css'

function Header(){

    return(
        <header>
            <div className="conteneur_header">
                <h1>Bucket-list Online</h1>
                <h3>Aide-memoire numerique</h3>
            </div>
        </header>
    )

}

export default Header;